import React, { useState, useEffect } from 'react';
import DynamicNavbar from '../components/DynamicNavbar';
import DynamicHero from '../components/DynamicHero';
import DynamicAbout from '../components/DynamicAbout';
import DynamicProducts from '../components/DynamicProducts'; // Changed from Products
import DynamicServices from '../components/DynamicServices';
import DynamicTraining from '../components/DynamicTraining';
import DynamicPartners from '../components/DynamicPartners';
import DynamicTeam from '../components/DynamicTeam';
import Testimonials from '../components/Testimonials';
import Events from '../components/Events';
import WhyUs from '../components/WhyUs';
import Career from '../components/Career';
import DynamicFooter from '../components/DynamicFooter';
import ContactModal from '../components/ContactModal';
import TrainingModal from '../components/TrainingModal';
import AOS from 'aos';
import 'aos/dist/aos.css';

function Home() {
  const [showContactModal, setShowContactModal] = useState(false);
  const [showTrainingModal, setShowTrainingModal] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 800, once: true, offset: 100 });
    
    const handleOpenContact = () => setShowContactModal(true);
    window.addEventListener('openContactModal', handleOpenContact);
    return () => window.removeEventListener('openContactModal', handleOpenContact);
  }, []);

  return (
    <>
      <DynamicNavbar 
        onContactClick={() => setShowContactModal(true)} 
        onTrainingClick={() => setShowTrainingModal(true)}
      />
      <DynamicHero onContactClick={() => setShowContactModal(true)} />
      <DynamicAbout />
      <DynamicProducts /> {/* This will now fetch from database */}
      <DynamicServices />
      <DynamicTraining onEnrollClick={() => setShowTrainingModal(true)} />
      <DynamicPartners  />
      <DynamicTeam />
      <Testimonials />
      <Events />
      <WhyUs />
      <Career onApplyClick={() => setShowContactModal(true)} />
      <DynamicFooter />
      
      <ContactModal isOpen={showContactModal} onClose={() => setShowContactModal(false)} />
      <TrainingModal isOpen={showTrainingModal} onClose={() => setShowTrainingModal(false)} />
    </>
  );
}

export default Home;